import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Modal } from 'antd';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import { APP_PAGES, PERMISSIONS, ENTITY_TYPES } from '../../../../../data/config/constants';
import { uniqueId, showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR } from '../../../../../data/assets/img';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as entityActions from '../../../../../data/redux/entity_details/actions';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import CustomHeader from '../../../../../components/customheader';
import TableCellAction from '../../../components/tablecellaction';
import ShowMessage from '../../../../../components/showmessage';
import EntityForm from '../../../components/entityform';

class Entities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search_text: "",
            filtered_entity: props.entity_details.entities,
            current_entity: {},
            modal_data: {
                title: "",
                show_create_entity: false,
            }
        };
    }

    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.ENTITIES, APP_PAGES.BOT_BUILDER);
    }

    componentDidMount() {
        const { actions, entity_details } = this.props;
        if (isEmpty(entity_details.entities)) {
            actions.fetchAllEntities();
        }
        if (!isEmpty(entity_details.active_entity_data)) {
            actions.updateEntityState({}, 'active_entity_data')
        }
    }

    componentWillReceiveProps(nextProps) {
        const { entity_details } = this.props;
        const { search_text } = this.state;
        if (!isEqual(nextProps.entity_details.entities, entity_details.entities)) {
            const data = [...nextProps.entity_details.entities];
            if (search_text.trim().length !== 0) {
                this.setState({
                    filtered_entity: this.filterEntityBySearchText(search_text, data)
                });
            } else {
                this.setState({
                    filtered_entity: data
                });
            }
        }
    }

    getEntitiesTableColumns = () => {
        const columns = [
            {
                title: "Name",
                key: "Name",
                dataIndex: "name"
            },
            {
                title: "Type",
                key: "Type",
                dataIndex: "type",
            },
            {
                title: "Description",
                key: "Description",
                dataIndex: "description",
            },
            {
                title: "Entity Action",
                key: "Action",
                dataIndex: "action",
            },
            {
                title: "Action",
                key: "clickAction",
                dataIndex: "clickAction",
                render: (text, record) => {
                    return (
                        <TableCellAction show_edit show_delete delete_popconfirm_title="Are you sure delete this entity?" handleEditClick={() => this.onClickEditEntity(record)} handleDeleteClick={() => this.deleteEntity(record)} />
                    );
                }
            },
        ];
        return columns;
    }

    handleEntitySearch = (event) => {
        const { entity_details } = this.props;
        const search_text = event.target.value;
        this.setState({
            search_text: search_text
        });
        this.setState({
            filtered_entity: this.filterEntityBySearchText(search_text, entity_details.entities),
        });
    }

    filterEntityBySearchText = (text, entities) => {
        return entities.filter((item) => {
            return (
                (item.name && item.name !== undefined && item.name.toLowerCase().indexOf(text.toLowerCase()) !== -1)
                || (item.type && item.type !== undefined && item.type.toLowerCase().indexOf(text.toLowerCase()) !== -1) ||
                (item.action && item.action !== undefined && item.action.toLowerCase().indexOf(text.toLowerCase()) !== -1)
            );
        });
    };

    onClickAddEntity = () => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.ENTITY, PERMISSIONS.ACTION_TYPES.CREATE)) {
            this.setState({
                modal_data: {
                    title: "Create Entity",
                    show_create_entity: true,
                }
            });
        } else {
            showMessage('warning', 'You have not permission to create entity.');
        }
    };

    onClickEditEntity = (entity) => {
        const { isActionPermitted, history, match } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.ENTITY, PERMISSIONS.ACTION_TYPES.CREATE)) {
            if (entity && entity.entityID && entity.type) {
                const url = `${match.path}/id=${entity.entityID}&type=${entity.type}`;
                history.push(url);
            } else {
                showMessage('error', 'Entity Id or Entity Type is missing.');
            }
        } else {
            showMessage('warning', 'You have not permission to update entity.');
        }
    };

    deleteEntity = (entity) => {
        const { isActionPermitted, actions } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.ENTITY, PERMISSIONS.ACTION_TYPES.CREATE)) {
            if (entity && entity.entityID) {
                const payload = {
                    entityID: entity.entityID
                };
                actions.deleteEntity(payload);
            } else {
                showMessage('error', 'Entity Id or Entity Type is missing.');
            }
        } else {
            showMessage('warning', 'You have not permission to delete entity.');
        }
    };

    closeModal = () => {
        this.setState({
            current_entity: {},
            modal_data: {
                title: "",
                show_create_entity: false,
            }
        });
    };

    updateCurrentEntity = (key, value) => {
        this.setState({
            current_entity: {
                ...this.state.current_entity,
                [key]: value,
            }
        })
    };

    addNewEntityChild = (new_child) => {
        const { current_entity } = this.state;
        if (current_entity.children) {
            const index = current_entity.children.findIndex((child) => child.toLowerCase() === new_child.toLowerCase());
            if (index === -1) {
                this.updateCurrentEntity('children', [...current_entity.children, new_child]);
            } else {
                showMessage('warning', 'You can not add duplicate child');
            }
        } else {
            this.updateCurrentEntity('children', [new_child]);
        }
    };

    deleteEntityChild = (index) => {
        const { current_entity } = this.state;
        if (current_entity.children) {
            const new_children = [...current_entity.children.slice(0, index), ...current_entity.children.slice(index + 1)];
            this.updateCurrentEntity('children', new_children);
        }
    }

    createEntity = () => {
        const { current_entity } = this.state;
        if (!isEmpty(current_entity)) {
            this.props.actions.createEntity(this.state.current_entity, this.closeModal);
        } else {
            showMessage('warning', 'please enter all entity details')
        }
    }

    render() {
        const { page_details, entity_details } = this.props;
        const { modal_data, current_entity } = this.state;
        const mobile = page_details.device_data.screen_width < 768;

        if (entity_details.loaders.entities_loading && !entity_details.loaders.entities_loaded) {
            return (
                <div className="ori-full-parent-height oriBotMessagesContainer">
                    <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                    <div className="ori-pad-10">
                        <CardRowTableLoader />
                    </div>
                </div>
            );
        }
        else if (!entity_details.loaders.entities_loading && entity_details.loaders.entities_loaded) {
            return (
                <div className="ori-full-parent-height ori-lr-pad-10 oriEntitiesContainer">
                    <CustomHeader title="Entities" first_button_text="+ Add Entity"  first_button_type="primary" onClickFirstButton={this.onClickAddEntity} search_placeholder="Search Entity" onChangeSearch={this.handleEntitySearch} bottom_bordered show_first_button show_search />
                    <div className="ori-tb-pad-10">
                        <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.getEntitiesTableColumns()} dataSource={this.state.filtered_entity} />
                    </div>
                    <Modal className="ori-modal-primary" title={modal_data.title} footer={null} maskClosable={false} visible={modal_data.show_create_entity} onCancel={this.closeModal}>
                        {
                            modal_data.show_create_entity &&
                            <EntityForm hide_entity_child={current_entity.type !== ENTITY_TYPES.HIERARCHICAL} entity_name={current_entity.name} onChangeEntityName={(e) => this.updateCurrentEntity('name', e.target.value)} entity_children={current_entity.children} addNewChild={this.addNewEntityChild} deleteChild={this.deleteEntityChild} entity_type_options={entity_details.entity_types} entity_type={current_entity.type} onChangeEntityType={(value) => this.updateCurrentEntity('type', value)} description={current_entity.description} onChangeDescription={(e) => this.updateCurrentEntity('description', e.target.value)} loading={entity_details.loaders.entity_creating} button_ok_text={entity_details.loaders.entity_creating ? "Creating" : "Create"} handleCancelClick={this.closeModal} handleOkClick={this.createEntity} />
                        }
                    </Modal>
                </div>
            );
        }
        else if (!entity_details.loaders.entities_loading && !entity_details.loaders.entities_loaded) {
            return (
                <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load entity details. please check your internet connection and reload the page." height={150} width={150} />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        entity_details: state.entity_details
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, entityActions), dispatch)
    };
}

Entities.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    entity_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Entities);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/entities/index.js